export const contentCategoryNavbar = [
    {
      text: "Content Category",
      icon: "mdi-note-outline",
      to: "/content-category",
    },
  ];
  